import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TermsCheckbox } from "@/components/TermsCheckbox";
import { EgresadoDisclaimer } from "@/components/EgresadoDisclaimer";

const dest = (rol) => (rol === "admin" || rol === "super_admin" ? "/admin" : rol === "empresa" ? "/empresa" : "/egresado");

const AcceptTerms = ({ pending, onDone, onError }) => {
  const [acepta, setAcepta] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/google/complete", { pending_token: pending.pending_token, acepta_terminos: acepta });
      await onDone(r.data);
    } catch (err) {
      onError(err.response?.data?.detail || "No se pudo crear la cuenta.");
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="card-brand p-7 max-w-md w-full space-y-4" data-testid="google-terms-form">
        <h1 className="h-section text-xl">Un paso más para crear tu cuenta</h1>
        <p className="text-sm text-[var(--brand-text-muted)]">Vas a ingresar como <b>{pending.email}</b>. Para completar el alta necesitamos que aceptes los Términos y Condiciones de uso.</p>
        <EgresadoDisclaimer testid="google-callback-disclaimer" className="" />
        <TermsCheckbox checked={acepta} onChange={setAcepta} testid="google-terms" />
        <button className="btn-primary w-full" disabled={!acepta || busy} data-testid="google-terms-submit">{busy ? "Creando cuenta…" : "Crear mi cuenta"}</button>
      </form>
    </div>
  );
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginToken } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(null);

  const finish = async (data) => {
    if (data.mfa_required) { navigate("/verificacion", { replace: true, state: data }); return; }
    await loginToken(data.access_token, data.refresh_token);
    navigate(dest(data.rol), { replace: true });
  };

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const q = new URLSearchParams(window.location.search);
    const code = q.get("code");
    const state = q.get("state");
    window.history.replaceState(null, "", "/auth/google");
    if (!code || !state) {
      setError(q.get("error") === "access_denied" ? "Cancelaste el ingreso con Google." : "Respuesta de Google inválida.");
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/google/callback", { code, state });
        if (r.data.needs_terms) setPending(r.data);
        else await finish(r.data);
      } catch (e) {
        setError(e.response?.data?.detail || "No se pudo ingresar con Google.");
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-6 text-center" data-testid="google-callback-error">
      <p className="font-heading text-[var(--brand-primary)]">{error}</p>
      <Link to="/ingresar" className="btn-primary" data-testid="google-callback-back">Volver a ingresar</Link>
    </div>
  );
  if (pending) return <AcceptTerms pending={pending} onDone={finish} onError={setError} />;
  return <div className="min-h-screen flex items-center justify-center font-heading text-[var(--brand-primary)]" data-testid="google-callback-loading">Ingresando…</div>;
}
